import Call from '../Call.v2';
import {objToQs} from '../Utils';

const BidderSourcesGraph = {
    get(filters) {
        return Call(`bidder/sourcesAggregated/?${objToQs(filters)}`);
    },
};

export default BidderSourcesGraph;



// WEBPACK FOOTER //
// ./src/services/API/components/BidderSourcesGraph.js